import React from "react";
import Joi from "joi-browser";
import Form from "./common/form";
import GoogleButton from 'react-google-button'
import * as userService from '../services/userService'
import auth from "../services/authService";

class RegisterForm extends Form {
  state = {
    data: { username: "", password: "", email: "", user_type: "Premium" },
    errors: {}
  };

  schema = {
    username: Joi.string()
      .required()
      .label("Username"),
    password: Joi.string()
      .required()
      .min(5)
      .label("Password"),
    email: Joi.string()
      .required()
      .email()
      .label("Email"),
    user_type: Joi.string()
      .required()
  };

  doSubmit = async () => {
    // Call the server
    try {
      const { data: { access_token: jwt, refresh_token: rjwt } } =
        await userService.register(this.state.data);
      auth.storeTokens(jwt, rjwt);
      window.location = '/';
    }
    catch(ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data.error;
        this.setState({ errors });
      }
    }
  };

  render() {
    return (
      <div className="container">
        <div className="center_div">
        <h1>Join Mailvogue</h1>
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("username", "Username")}
          {this.renderInput("password", "Password", "password")}
          {this.renderInput("email", "Email")}
          {this.renderButton("Register")}
        </form>
        <hr />
        <GoogleButton
          type="dark"
          onClick={() => { window.location.href = process.env.REACT_APP_BASE_URL + "login/google"; }} />
        </div>
      </div>
    );
  }
}

export default RegisterForm;
